<template>
    <!-- main area start here  -->
    <main>
        <!-- breadcrumb area start here -->
        <section class="bd-breadcrumb-area p-relative fix theme-bg">
            <!-- breadcrumb background image -->
            <div class="bd-breadcrumb-bg" :style="{ backgroundImage: 'url(/img/bg/breadcrumb-bg.jpg)' }"></div>


            <div class="bd-breadcrumb-wrapper mb-60 p-relative">
                <div class="container">
                    <div class="bd-breadcrumb-shape d-none d-sm-block p-relative">
                        <div class="bd-breadcrumb-shape-1">
                        </div>
                        <div class="bd-breadcrumb-shape-2">
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-xl-10">
                            <div class="bd-breadcrumb d-flex align-items-center justify-content-center">
                                <div class="bd-breadcrumb-content text-center">
                                    <h1 class="bd-breadcrumb-title">About School</h1>
                                    <div class="bd-breadcrumb-list">
                                        <span><a href="/"><i class="flaticon-hut"></i>Home</a></span>
                                        <div class="bd-breadcrumb-list">
                                            <span><a href="#">About</a></span>
                                        </div>
                                        <span>About School</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bd-wave-wrapper bd-wave-wrapper-3">
                <div class="bd-wave bd-wave-3"></div>
                <div class="bd-wave bd-wave-3"></div>
            </div>
        </section>
        <!-- breadcrumb area end here  -->

        <!-- program details slider area start here  -->
        <section class="bd-program-details-widget pt-120 pb-70">
            <div class="container">
                <div class="row">
                    <div class="col-xl-6 col-lg-12 mb-50">
                        <div class="bd-program-details-slider p-relative wow fadeInLeft" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <div class="bd-program-details-active swiper-container">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide">
                                        <div class="bd-program-details-slider-thumb">
                                            <img src="/img/about/S1.png" alt="img not found!">
                                        </div>
                                    </div>
                                    <div class="swiper-slide">
                                        <div class="bd-program-details-slider-thumb">
                                            <img src="/img/about/S2.png" alt="img not found!">
                                        </div>
                                    </div>
                                    <div class="swiper-slide">
                                        <div class="bd-program-details-slider-thumb">
                                            <img src="/img/about/S3.png" alt="img not found!">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- program details slider navigation  -->
                            <div class="bd-program-details-navigation mb-15 d-none d-sm-flex">
                                <button class="bd-program-details-next">
                                    <i class="fa-regular fa-angle-right"></i>
                                </button>
                                <button class="bd-program-details-prev">
                                    <i class="fa-regular fa-angle-left"></i>
                                </button>
                            </div>
                            <div class="panel wow"></div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-12 mb-50">
                        <div class="bd-program-details-widget-content theme-bg-6 wow fadeInRight" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <h3 class="bd-program-details-widget-title mb-20">Baburam Vedanta School (BVS)</h3>
                            <p class="mb-25">Baburam Vedanta School (BVS), established in 2014, is a reputed educational institution located in Bharatpur, Rajasthan. Affiliated with the Rajasthan Board of Secondary Education (RBSE), the school provides quality education in an English-medium, co-educational environment.</p>
                            <p class="mb-25">BVS is committed to providing a supportive learning environment with good infrastructure and facilities that promote academic excellence and the overall development of students. The school's philosophy of “High Quality Education at an Affordable Cost” reflects its commitment to making quality education accessible to students from all backgrounds.</p>
                            <p class="mb-25">At BVS, the teaching methodology focuses on developing students' academic knowledge, practical skills, creativity, confidence, and moral values. The school encourages students to participate actively in both academic and extracurricular activities, helping them develop into responsible, capable, and well-rounded individuals prepared for future challenges.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- program details slider area end here  -->

        <!-- Vision area start here  -->
        <section class="bd-testimonial-area theme-bg" style="background-color: #73bf43;">
            <div class="bd-testimonial-video"
                style="background-image: url('/img/about/vision.png'); background-size: cover; background-position: center;">
            </div>

            <div class="bd-testimonial-bg d-none d-lg-block"></div>
            <div class="container">
                <div class="row justify-content-end align-items-center">
                    <div class="col-lg-6">
                        <div class="bd-testimonial-wrapper pt-120 pb-120">
                            <div class="bd-section-title-wrapper is-white mb-20 wow fadeInUp" data-wow-duration="1s"
                                data-wow-delay=".3s">
                                <h2 class="bd-section-title mb-0">Vision</h2>
                            </div>
                            <div class="bd-testimonial-active swiper-container wow fadeInUp" data-wow-duration="1s"
                                data-wow-delay=".5s">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide">
                                        <div class="bd-testimonial">
                                            <div class="bd-testimonial-content mb-55">
                                                <p>To empower, shape, develop, and nurture the potential of every child
                                                    through innovative and value-based education making them a
                                                    responsible citizen of our country.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
        <hr />
        <section class="bd-testimonial-area theme-bg" style="background-color: #73bf43;">
            <div class="bd-testimonial-video"
                style="background-image: url('/img/about/mission.png'); background-size: cover; background-position: center;">
            </div>
            <div class="bd-testimonial-bg d-none d-lg-block"></div>
            <div class="container">
                <div class="row justify-content-end align-items-center">
                    <div class="col-lg-6">
                        <div class="bd-testimonial-wrapper pt-120 pb-120">
                            <div class="bd-section-title-wrapper is-white mb-20 wow fadeInUp" data-wow-duration="1s"
                                data-wow-delay=".3s">
                                <h2 class="bd-section-title mb-0">Mission</h2>
                            </div>
                            <div class="bd-testimonial-active swiper-container wow fadeInUp" data-wow-duration="1s"
                                data-wow-delay=".5s">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide">
                                        <div class="bd-testimonial">
                                            <div class="bd-testimonial-content mb-55">
                                                <p>Provide holistic education at an affordable cost to eliminate the
                                                    educational inequality in India.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Vision area end here  -->

        <!-- promotion area start here  -->
        <section class="bd-promotion-area-2 pt-120 pb-60 fix">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-xl-6 col-lg-6">
                        <div class="bd-promotion bd-promotion-2 mb-60 wow fadeInLeft" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <div class="bd-section-title-wrapper mb-35">
                                <h2 class="bd-section-title mb-10">Nurturing Holistic Growth</h2>
                                <span class="mb-10 d-inline-block">
                                    Baburam Vedanta School (BVS) believes that every child has the potential to learn, grow, and achieve excellence.
                                </span>
                                <p>With a commitment to holistic education, we strive to nurture young minds by fostering knowledge, creativity, confidence, and strong moral values. Our goal is to empower students to become responsible, compassionate, and forward-thinking individuals who contribute positively to society and build a brighter future.</p>
                            </div>
                            <div class="bd-promotion-list-2 d-none">
                                <ul>
                                    <li>
                                        <div class="bd-promotion-icon">
                                            <i class="flaticon-exclusive theme-bg-2"></i>
                                        </div>
                                        <span><a href="/" target="_blank">Normal School</a></span>
                                    </li>
                                    <li>
                                        <div class="bd-promotion-icon">
                                            <i class="flaticon-wishlist theme-bg"></i>
                                        </div>
                                        <span><a href="https://vedantafoundation.org/vmr_special_school.html"
                                                target="_blank">Special School</a></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6">
                        <div class="bd-promotion-thumb-wrapper mb-60 wow fadeInRight" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <div class="bd-promotion-thumb">
                                <div class="bd-promotion-thumb-maskx p-relative">
                                    <img src="/img/about/atm_1.png" alt="Image not found" style="border-radius: 1rem;">
                                    <div class="panel-2 wow"></div>
                                </div>
                            </div>
                            <div class="bd-promotion-shape d-none d-lg-block">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- promotion area end here  -->

        <!-- feature area start here-->
        <div class="bd-feature-area p-relative theme-bg pt-120 pb-120">
            <div class="bd-feature-bottom-shape">
                <img src="/img/shape/wave-section-break.png" alt="img not found!">
            </div>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-8 col-md-10">
                        <div class="bd-section-title-wrapper is-white text-center mb-55 wow fadeInUp"
                            data-wow-duration="1s" data-wow-delay=".3s">
                            <h2 class="bd-section-title mb-0">Explore Excellence</h2>
                            <p>Unveiling the Key Features that
                                Define Baburam Vedanta School's
                                Distinctive Educational Journey
                            </p>
                        </div>
                    </div>
                </div>
                <div class="bd-feature-wrapper wow fadeInUp" data-wow-duration="1s" data-wow-delay=".5s">
                    <div class="row">
                        <div class="col-12">
                            <ul class="feature">
                                <li class="feature-item">
                                    <div class="bd-feature">
                                        <div class="bd-feature-content">
                                            <div class="bd-feature-icon icon-1">
                                                <i class="flaticon-checkmark"></i>
                                            </div>
                                            <h4 class="bd-feature-title">Affordable Fees</h4>
                                            <p>Making education accessible to all.</p>
                                        </div>
                                    </div>
                                </li>
                                <li class="feature-item">
                                    <div class="bd-feature">
                                        <div class="bd-feature-content">
                                            <div class="bd-feature-icon icon-2">
                                                <i class="flaticon-reading"></i>
                                            </div>
                                            <h4 class="bd-feature-title">Scholarship</h4>
                                            <p>Scholarships to deserving and meritorious students</p>
                                        </div>
                                    </div>
                                </li>
                                <li class="feature-item">
                                    <div class="bd-feature">
                                        <div class="bd-feature-content">
                                            <div class="bd-feature-icon icon-3">
                                                <i class="flaticon-time"></i>
                                            </div>
                                            <h4 class="bd-feature-title">Extra Classes</h4>
                                            <p>Additional classes for 10th and 12th-grade students</p>
                                        </div>
                                    </div>
                                </li>
                                <li class="feature-item">
                                    <div class="bd-feature first-item">
                                        <div class="bd-feature-content">
                                            <div class="bd-feature-icon icon-4">
                                                <i class="flaticon-menu"></i>
                                            </div>
                                            <h4 class="bd-feature-title">Academic Excellence</h4>
                                            <p>Comprehensive curriculum
                                                for holistic development</p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <hr style="color: white;" />
                    <div class="row">
                        <div class="col-12">
                            <ul class="feature">
                                <li class="feature-item">
                                    <div class="bd-feature">
                                        <div class="bd-feature-content">
                                            <div class="bd-feature-icon icon-1">
                                                <i class="flaticon-swing"></i>
                                            </div>
                                            <h4 class="bd-feature-title">RTE Students</h4>
                                            <p>25% seats reserved to ensure equal
                                                opportunities</p>
                                        </div>
                                    </div>
                                </li>
                                <li class="feature-item">
                                    <div class="bd-feature">
                                        <div class="bd-feature-content">
                                            <div class="bd-feature-icon icon-2">
                                                <i class="flaticon-delivery"></i>
                                            </div>
                                            <h4 class="bd-feature-title">Transport Facility</h4>
                                            <p>Transport Facility available for nearby villages</p>
                                        </div>
                                    </div>
                                </li>
                                <li class="feature-item">
                                    <div class="bd-feature">
                                        <div class="bd-feature-content">
                                            <div class="bd-feature-icon icon-3">
                                                <i class="flaticon-presentation"></i>
                                            </div>
                                            <h4 class="bd-feature-title">Smart Classrooms</h4>
                                            <p>Embracing modern educational technology</p>
                                        </div>
                                    </div>
                                </li>
                                <li class="feature-item">
                                    <div class="bd-feature first-item">
                                        <div class="bd-feature-content">
                                            <div class="bd-feature-icon icon-4">
                                                <i class="flaticon-teacher"></i>
                                            </div>
                                            <h4 class="bd-feature-title">Experienced faculties</h4>
                                            <p>Holistic development and well-being of each
                                                student.</p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- feature area end here-->

        <!-- teacher area start here  -->
        <section class="bd-teacher-area pt-120">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-8">
                        <div class="bd-section-title-wrapper text-center mb-55 wow fadeInUp" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <h2 class="bd-section-title mb-0">Management Committee</h2>
                            <p>Meet the dedicated Management Committee
                                shaping the vision and direction of Baburam Vedanta School.</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12" style="text-align: center;">
                        <div class="bd-header-btn d-none d-xl-block">
                            <a href="/documents/management_committee.pdf" target="_blank" class="bd-btn">
                                <span class="bd-btn-inner">
                                    <span class="bd-btn-normal">Click Here</span>
                                    <span class="bd-btn-hover">Click Here</span>
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- teacher area end here  -->

        <!-- counter area start here  -->
        <div class="bd-counter-area-2 pb-90" style="display: none;">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-4 col-md-10 col-sm-10">
                        <div class="bd-counter-2 mb-30">
                            <div class="bd-counter-2-icon">
                                <i class="flaticon-user-interface"></i>
                            </div>
                            <div class="bd-counter-2-content">
                                <div class="bd-counter-2-number">
                                    <span class="odometer" data-count="15">15</span><span>+</span>
                                </div>
                                <div class="bd-counter-2-text">
                                    <span>years of
                                        <br>experience</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-10 col-sm-10">
                        <div class="bd-counter-2 mb-30">
                            <div class="bd-counter-2-icon">
                                <i class="flaticon-reading"></i>
                            </div>
                            <div class="bd-counter-2-content">
                                <div class="bd-counter-2-number">
                                    <span class="odometer" data-count="2">2</span><span>K+</span>
                                </div>
                                <div class="bd-counter-2-text">
                                    <span>Students
                                        <br>each year</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-10 col-sm-10">
                        <div class="bd-counter-2 mb-30">
                            <div class="bd-counter-2-icon">
                                <i class="flaticon-badge"></i>
                            </div>
                            <div class="bd-counter-2-content">
                                <div class="bd-counter-2-number">
                                    <span class="odometer" data-count="65">65</span><span>+</span>
                                </div>
                                <div class="bd-counter-2-text">
                                    <span>Qualified
                                        <br> Staff</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- counter area end here  -->

    </main>
    <!-- main area end here  -->
</template>
<script>
export default {
    name: "AboutPageView",
};
</script>
